import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';

import $ from 'jquery';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import Input from '../../components/Form/Input';
import FormButton from '../../components/Form/Button';
import FormSelect from '../../components/Form/FormSelect';
import { feedbacks, influences, projectTypes } from '../../data';

const FeedbackCreate = () => {
      const [loadingData, setLoadingData] = useState(false);

      const [firstName, setFirstName] = useState('');
      const [lastName, setLastName] = useState('');
      const [occupation, setOccupation] = useState('');
      const [email, setEmail] = useState('');
      const [phoneNumber, setPhoneNumber] = useState('');
      const [address, setAddress] = useState('');
      const [feedback, setFeedback] = useState('');
      const [productFeedback, setProductFeedback] = useState('');
      const [serviceFeedback, setServiceFeedback] = useState('');
      const [projectName, setProjectName] = useState('');
      const [projectType, setProjectType] = useState('');
      const [influence, setInfluence] = useState('');
      const [loading, setLoading] = useState(false);

      const token = JSON.parse(localStorage.getItem('token'));

      const handleForm = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  first_name: firstName,
                  last_name: lastName,
                  occupation: occupation,
                  email: email,
                  phone_number: phoneNumber,
                  address: address,
                  project_name: projectName,
                  project_type: projectType,
                  feedback: feedback,
                  product_feedback: productFeedback,
                  service_feedback: serviceFeedback,
                  influence: influence
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/feedbacks`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                              $('form').trigger('reset');
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.first_name) {
                                    toast.error(
                                          response.data.message.first_name
                                    );
                              }
                              if (response.data.message.last_name) {
                                    toast.error(
                                          response.data.message.last_name
                                    );
                              }
                              if (response.data.message.email) {
                                    toast.error(response.data.message.email);
                              }
                              if (response.data.message.phone_number) {
                                    toast.error(
                                          response.data.message.phone_number
                                    );
                              }
                              if (response.data.message.address) {
                                    toast.error(response.data.message.address);
                              }
                              if (response.data.message.project_name) {
                                    toast.error(
                                          response.data.message.project_name
                                    );
                              }
                              if (response.data.message.project_type) {
                                    toast.error(
                                          response.data.message.project_type
                                    );
                              }
                              if (response.data.message.feedback) {
                                    toast.error(response.data.message.feedback);
                              }
                              if (response.data.message.occupation) {
                                    toast.error(
                                          response.data.message.occupation
                                    );
                              }
                              if (response.data.message.product_feedback) {
                                    toast.error(
                                          response.data.message.product_feedback
                                    );
                              }
                              if (response.data.message.service_feedback) {
                                    toast.error(
                                          response.data.message.service_feedback
                                    );
                              }
                              if (response.data.message.influence) {
                                    toast.error(
                                          response.data.message.influence
                                    );
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleForm}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader>
                                                <CardTitle>
                                                      Create New Feedback
                                                </CardTitle>
                                                <CardLinks>
                                                      <LinkButton to="/dashboard/feedbacks">
                                                            Back
                                                      </LinkButton>
                                                </CardLinks>
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <Input
                                                            title="First Name"
                                                            classes={4}
                                                            required={true}
                                                            handleChange={
                                                                  setFirstName
                                                            }
                                                      />
                                                      <Input
                                                            title="Last Name"
                                                            classes={4}
                                                            required={true}
                                                            handleChange={
                                                                  setLastName
                                                            }
                                                      />
                                                      <Input
                                                            title="Occupation"
                                                            classes={4}
                                                            required={true}
                                                            handleChange={
                                                                  setOccupation
                                                            }
                                                      />
                                                      <Input
                                                            title="Email Address"
                                                            classes={4}
                                                            handleChange={
                                                                  setEmail
                                                            }
                                                      />
                                                      <Input
                                                            title="Phone No."
                                                            classes={4}
                                                            required={true}
                                                            handleChange={
                                                                  setPhoneNumber
                                                            }
                                                      />
                                                      <Input
                                                            title="Address"
                                                            classes={4}
                                                            required={true}
                                                            handleChange={
                                                                  setAddress
                                                            }
                                                      />
                                                      <Input
                                                            title="Project Name"
                                                            classes={4}
                                                            handleChange={
                                                                  setProjectName
                                                            }
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            classes={4}
                                                            title="Project Type"
                                                            setData={
                                                                  setProjectType
                                                            }
                                                            options={
                                                                  projectTypes
                                                            }
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            classes={4}
                                                            title="How do you hear about us?"
                                                            setData={
                                                                  setInfluence
                                                            }
                                                            required={true}
                                                            options={influences}
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            classes={4}
                                                            title="Display Feedback"
                                                            setData={
                                                                  setFeedback
                                                            }
                                                            required={true}
                                                            options={feedbacks}
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            classes={4}
                                                            title="Quality of Product"
                                                            setData={
                                                                  setProductFeedback
                                                            }
                                                            required={true}
                                                            options={feedbacks}
                                                      />
                                                      <FormSelect
                                                            loading={
                                                                  loadingData
                                                            }
                                                            classes={4}
                                                            title="Quality of Service"
                                                            setData={
                                                                  setServiceFeedback
                                                            }
                                                            required={true}
                                                            options={feedbacks}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Submit"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default FeedbackCreate;
